
import React, { useState } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function VhmdTrace() {
    const [selectedParameter, setSelectedParameter] = useState(null);
    const [searchText, setSearchText] = useState("");

    const vehicleOptions = [...Array(10).keys()].map((i) => ({
        value: `KA0${i + 1}AB1234`,
        label: `KA0${i + 1}AB1234`,
    }));
    const data = [
        { id: 1, vehicleId: "V1001", vehicleNumber: "KA01AB1234", sensor: "Active", time: "2025-02-24 10:15:30", ignition: "ON", soc: "85%", speed: "60 km/h", odo: "15000 km", range: "250 km", gear: "D" },
        { id: 2, vehicleId: "V1002", vehicleNumber: "MH12CD5678", sensor: "Active", time: "2025-02-24 10:20:45", ignition: "ON", soc: "75%", speed: "45 km/h", odo: "22000 km", range: "180 km", gear: "N" },
    ];
    const columns = [
        { name: "ID", selector: (row) => row.id, sortable: true },
        { name: "Vehicle ID", selector: (row) => row.vehicleId, sortable: true },
        { name: "Vehicle Number", selector: (row) => row.vehicleNumber, sortable: true },
        { name: "Sensor", selector: (row) => row.sensor, sortable: true },
        { name: "Time", selector: (row) => row.time, sortable: true },
        { name: "Ignition", selector: (row) => row.ignition, sortable: true },
        { name: "SoC", selector: (row) => row.soc, sortable: true },
        { name: "Speed", selector: (row) => row.speed, sortable: true },
        { name: "ODO", selector: (row) => row.odo, sortable: true },
        { name: "Range", selector: (row) => row.range, sortable: true },
        { name: "Gear", selector: (row) => row.gear, sortable: true },
    ];

     const handleExportPDF = () => {
        const doc = new jsPDF();
        autoTable(doc, {
            head: [columns.map((col) => col.name)],
            body: filteredData.map((row) => columns.map((col) => row[col.selector ? col.selector(row) : row[col.name]])),
        });
        doc.save("trips-data.pdf");
    };
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#888888 ",
                color: "#ffffff",
                fontWeight: "bold",
            },
        },
    };
    const filteredData = data.filter((row) =>
        Object.values(row).some((val) =>
            val.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Vhmd Trace   </h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="#/">Dashboard</a></li>
                                <li className="breadcrumb-item active">Vhmd Trace</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header p-1 pt-2">
                            <div className="row mb-3 d-flex justify-content-center">
                                <div className="col-sm-12 col-md-12 col-lg-3 mb-1">
                                    <label>Select Vehicle</label>
                                    <Select
                                        options={vehicleOptions}
                                        value={selectedParameter}
                                        onChange={setSelectedParameter}
                                        isSearchable={true} // Enables search
                                        placeholder="Select Vehicle"
                                        className="basic-single"
                                        classNamePrefix="select"
                                    />
                                </div>

                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>From</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                    <label>To</label>
                                    <input type="date" className="form-control" />
                                </div>
                                <div className="col-md-1 mt-4">
                                    <input type="submit" value="Search" className="mt-1 btn btn-primary waves-effect waves-light" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <div>
                                    <CSVLink data={filteredData} filename="trips-data.csv" className="btn btn-primary btn-sm me-2">
                                        Export to CSV
                                    </CSVLink>
                                    <button onClick={handleExportPDF} className="btn btn-danger btn-sm">
                                        Export to PDF
                                    </button>
                                </div>
                                <div className="col-lg-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>
                            </div>
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
